/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21 5V19"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.93042 17.8304C7.3245 18.8628 6.52153 19.379 5.85752 19.3316C5.27885 19.2903 4.74665 18.9997 4.39897 18.5353C4 18.0024 4 17.0478 4 15.1387V8.86133C4 6.95219 4 5.99762 4.39897 5.46471C4.74665 5.0003 5.27885 4.70974 5.85752 4.66841C6.52153 4.62099 7.3245 5.13718 8.93043 6.16956L13.8128 9.30823C15.2063 10.2041 15.9031 10.652 16.1438 11.2216C16.3541 11.7192 16.3541 12.2808 16.1438 12.7784C15.9031 13.348 15.2063 13.7959 13.8128 14.6918L8.93042 17.8304Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M8.93042 17.8304C7.3245 18.8628 6.52153 19.379 5.85752 19.3316C5.27885 19.2903 4.74665 18.9997 4.39897 18.5353C4 18.0024 4 17.0478 4 15.1387V8.86133C4 6.95219 4 5.99762 4.39897 5.46471C4.74665 5.0003 5.27885 4.70974 5.85752 4.66841C6.52153 4.62099 7.3245 5.13718 8.93043 6.16956L13.8128 9.30823C15.2063 10.2041 15.9031 10.652 16.1438 11.2216C16.3541 11.7192 16.3541 12.2808 16.1438 12.7784C15.9031 13.348 15.2063 13.7959 13.8128 14.6918L8.93042 17.8304Z"
				fill="currentColor"
			/>
			<path
				d="M21 5V19M13.8128 14.6918L8.93042 17.8304C7.3245 18.8628 6.52153 19.379 5.85752 19.3316C5.27885 19.2903 4.74665 18.9997 4.39897 18.5353C4 18.0024 4 17.0478 4 15.1387V8.86133C4 6.95219 4 5.99762 4.39897 5.46471C4.74665 5.0003 5.27885 4.70974 5.85752 4.66841C6.52153 4.62099 7.3245 5.13718 8.93043 6.16956L13.8128 9.30823C15.2063 10.2041 15.9031 10.652 16.1438 11.2216C16.3541 11.7192 16.3541 12.2808 16.1438 12.7784C15.9031 13.348 15.2063 13.7959 13.8128 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.336 5.53865L9.3036 5.51783L9.30359 5.51782C8.52813 5.0193 7.90212 4.61686 7.38702 4.34876C6.87061 4.07997 6.34982 3.88132 5.80408 3.9203C5.00842 3.97713 4.27664 4.37664 3.79858 5.0152C3.47068 5.45319 3.35616 5.99868 3.303 6.57843C3.24998 7.1567 3.24999 7.90091 3.25 8.8228V8.82281V8.86131V15.1386V15.1771V15.1772C3.24999 16.099 3.24998 16.8433 3.303 17.4215C3.35616 18.0013 3.47068 18.5468 3.79858 18.9848C4.27664 19.6233 5.00842 20.0228 5.80408 20.0797C6.34982 20.1186 6.87061 19.92 7.38702 19.6512C7.90213 19.3831 8.52816 18.9806 9.30365 18.4821L9.33599 18.4613L14.2184 15.3226L14.2495 15.3026L14.2495 15.3026C14.9198 14.8717 15.4663 14.5204 15.8718 14.2041C16.284 13.8827 16.6395 13.5322 16.8346 13.0703C17.1238 12.3861 17.1238 11.6139 16.8346 10.9296C16.6395 10.4678 16.284 10.1172 15.8718 9.79582C15.4663 9.47952 14.9198 9.12824 14.2495 8.69733L14.2495 8.69732L14.2184 8.67732L9.336 5.53865ZM21.75 4.99998C21.75 4.58577 21.4142 4.24998 21 4.24998C20.5858 4.24998 20.25 4.58577 20.25 4.99998V19C20.25 19.4142 20.5858 19.75 21 19.75C21.4142 19.75 21.75 19.4142 21.75 19V4.99998Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 5V19M13 8.78571L13.8128 9.30823C15.2063 10.2041 15.9031 10.652 16.1438 11.2216C16.3541 11.7192 16.3541 12.2808 16.1438 12.7784C15.9031 13.348 15.2063 13.7959 13.8128 14.6918L8.93042 17.8304C7.3245 18.8628 6.52153 19.379 5.85752 19.3316C5.27885 19.2903 4.74665 18.9997 4.39897 18.5353C4 18.0024 4 17.0478 4 15.1387V14M10 6.85714L8.93043 6.16956C7.3245 5.13718 6.52153 4.62099 5.85752 4.66841C5.27885 4.70974 4.74665 5.0003 4.39897 5.46471C4 5.99762 4 6.95219 4 8.86133V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 5V19M13.8128 14.6918L8.93042 17.8304C7.3245 18.8628 6.52153 19.379 5.85752 19.3316C5.27885 19.2903 4.74665 18.9997 4.39897 18.5353C4 18.0024 4 17.0478 4 15.1387V8.86133C4 6.95219 4 5.99762 4.39897 5.46471C4.74665 5.0003 5.27885 4.70974 5.85752 4.66841C6.52153 4.62099 7.3245 5.13718 8.93043 6.16956L13.8128 9.30823C15.2063 10.2041 15.9031 10.652 16.1438 11.2216C16.3541 11.7192 16.3541 12.2808 16.1438 12.7784C15.9031 13.348 15.2063 13.7959 13.8128 14.6918Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.41303 5.58817C7.40562 4.29769 6.40192 3.65245 5.57189 3.71174C4.84857 3.7634 4.18331 4.1266 3.74871 4.70711C3.25 5.37325 3.25 6.56646 3.25 8.95288V15.0471C3.25 17.4335 3.25 18.6267 3.74871 19.2928C4.18331 19.8733 4.84857 20.2365 5.57189 20.2882C6.40192 20.3475 7.40562 19.7022 9.41303 18.4118L14.1529 15.3647C15.8949 14.2449 16.7658 13.685 17.0667 12.973C17.3295 12.3509 17.3295 11.649 17.0667 11.0269C16.7658 10.315 15.8949 9.75507 14.1529 8.63525L9.41303 5.58817Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21 4.25012C21.4142 4.25012 21.75 4.58591 21.75 5.00012V19.0001C21.75 19.4143 21.4142 19.7501 21 19.7501C20.5858 19.7501 20.25 19.4143 20.25 19.0001V5.00012C20.25 4.58591 20.5858 4.25012 21 4.25012Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
